import React, { useState, useEffect } from 'react';
import styles from '../../Sales.module.scss';
import { connect } from 'react-redux';
import { RootState } from '../../../../store';
import { Dispatch } from 'redux';
import { isEmpty, clone } from 'lodash';

//components
import { SalesTableItem } from './SalesTableItem';

//data
import { dashboardActions } from '../../../../store/dashboard/actions';
//Tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../utils/translations/translator';
//assets

import { CsvDownloaderHandler } from '../../Utils/CsvDownloadHandler';
import { DashboardState } from '../../../../store/dashboard/reducer';
import { Sale } from '../../../../sagas/dashboard/types';

interface DispatchProps {
  dashboardState: DashboardState;
}
interface OwnProps {
  transactionsData: any;
  downloadAllCsv: () => void;
  isLoading: boolean;
  navigateToPage: (cursor: string) => void;
  page: number;
  setPage: (page: number) => void;
  isRequested: boolean;
  userId: string;
  getAllCsvEarnings: (options: {
    download_type: 'earnings';
    period_filter: string;
    type_filter: string;
  }) => void;
  periodFilter: { key: string; label: string };
  typeFilter: { key: string; label: string };
}

export const SalesTable: React.FC<OwnProps & DispatchProps> = ({
  transactionsData,
  downloadAllCsv,
  dashboardState,
  isLoading,
  navigateToPage,
  page,
  setPage,
  isRequested,
  userId,
  getAllCsvEarnings,
  periodFilter,
  typeFilter,
}) => {
  const { t } = useTranslation();

  const transactions = isEmpty(transactionsData) ? undefined : transactionsData;

  const [isNextPageLoading, setIsNextPageLoading] = useState(false);

  const nextPage = () => {
    setIsNextPageLoading(true);
    setPage(page + 1);
    navigateToPage(transactions[transactions.length - 1].ID);
    setIsNextPageLoading(false);
  };

  const limit = 50;

  const isDisabled =
    !transactions ||
    transactions.length < limit * page ||
    isNextPageLoading ||
    isLoading ||
    !isRequested;

  useEffect(() => {
    getAllCsvEarnings({
      download_type: 'earnings',
      period_filter: periodFilter.key,
      type_filter: typeFilter.key,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const groupTransactionsByDate: () => any = () => {
    let newObj = clone(transactions).reduce((h: any, sale: Sale) => {
      return Object.assign(h, {
        [sale.createdAt.format('DD/MM/YYYY')]: (
          h[sale.createdAt.format('DD/MM/YYYY')] || []
        ).concat(sale),
      });
    }, {});

    const keys = Object.keys(newObj);
    return keys.map((key) => (
      <div key={key}>
        <div className={styles.header}>
          <label>{key}</label>
        </div>

        {newObj[key].map((transaction: Sale, index: number) => (
          <SalesTableItem
            transaction={transaction}
            key={transaction.ID + index}
          />
        ))}
      </div>
    ));
  };

  return (
    <div className={styles.earningsTransactions}>
      <div className={styles.tableWrapperEarnings}>
        <div className={styles.divisionLine} />
        <div className={styles.transactionsHeader}>
          <h2>{tr(t, 'transactions')}</h2>
          <CsvDownloaderHandler
            data={downloadAllCsv}
            properties={'earnings'}
            userId={userId}
            isLoading={dashboardState.isLoadingCsv}
          />
        </div>
        {!isRequested ? (
          <div className={styles.emptyState}>
            <label>{tr(t, 'loading')}...</label>
          </div>
        ) : transactions ? (
          <div className={styles.transactionsWrapper}>
            <div className={styles.rowHeader}>
              <div>
                <label>{tr(t, 'product')}</label>
              </div>
              <div>
                <label>{tr(t, 'country')}</label>
              </div>
              <div>
                <label>{tr(t, 'platform')}</label>
              </div>
              <div>
                <label>{tr(t, 'total')}</label>
              </div>
            </div>
            {groupTransactionsByDate()}
          </div>
        ) : (
          <div className={styles.emptyState}>
            <label>{tr(t, 'no-data')}</label>
          </div>
        )}
      </div>
      <div className={styles.navigationBtnWrapper}>
        {(isLoading || isNextPageLoading) && (
          <label className={styles.loading}>{tr(t, 'loading')}...</label>
        )}
        <button
          className={
            !transactions || transactions.length < limit * page
              ? styles.hidden
              : styles.next
          }
          disabled={isDisabled}
          onClick={() => nextPage()}
        >
          {tr(t, 'see-more')}
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  dashboardState: state.dashboard,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getAllCsvEarnings: (queryparams: any) =>
    dispatch(dashboardActions.downloadAllCsvRequestAction(queryparams)),
});

export const SalesTableConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SalesTable);
